import commonService from "./common";
import sessionIdDirective from "../directive/sessionId-directive";
import initService from "./init-service";
let pId = sessionIdDirective.getJSessionId();
let headers = {
  headers: {
    'Content-Type': 'application/json',
  }
};

const HomeDashboardService = {

  getServerStatus() {
    let param = `healthcheck&targets=`+process.env.VUE_APP_CLIENT;
    return commonService.commonAPI(param)
        .then(response => response.data.message)
        .catch(error => console.error(error))
  },

  getCurrentUserInfo() {
    let param = 'IOT_GetCurrentUser';
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

//removed as it is now on the get current user response
  // getCurrentCustomerInfo() {
  //   let group = JSON.parse(sessionStorage.getItem('IOT_GetCurrentUser'))['groups'][0];
  //   console.log(JSON.parse(sessionStorage.getItem('IOT_GetCurrentUser')))
  //   let url = `${process.env.VUE_APP_CONFIG_BASEURL}?method=IOT_GetCustomerInfo&group=${group}&pid=${pId}`;
  //   return Vue.axios.get(url, headers)
  //     .then(response => response.data.message)
  //     .catch(error => console.error(error))
  // },

   getVersion() {
     //return process.env.VUE_APP_UX_VERSION;
     let param = 'getversion';
     return commonService.commonAPI(param)
         .then(response => response.data.message)
         .catch(error => console.error(error))
   },

  getDataSessionStatistic(imsi, period) {
    let param = `IOT_GetTotalDataSessionsByPeriod&period=${period}&imsi=${imsi}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getDataVolumeStatistic(imsi, period) {
    let param = `IOT_GetTotalDataVolumesByPeriod&period=${period}&imsi=${imsi}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getAlertsStatistic(imsi, period) {
    let param = `IOT_GetTotalAlertsByPeriod&period=${period}&imsi=${imsi}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getZeroSessionStatistic(imsi, period) {
    let param = `IOT_GetTotalZeroSessionsByPeriod&period=${period}&imsi=${imsi}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getDataVolumeTrendByPeriod(period) {
    let param = `IOT_GetDataVolumeSummaryByPeriod&period=${period}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getDataVolumeAverage() {
    let param = `IOT_GetAverageDataVolumes`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getTopMetrics(method) {
    let param = `IOT_GetTopMetrics${method}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getTopicMetricsAlerts(method) {
    let param = `IOT_Get${method}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getVolumeByRegion(period) {
    let param = `IOT_GetDataVolumeSummaryByRegion_map&period=${period}`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  },

  getSimInventory() {
    let param = `IOT_GetSimInventory`;
    return commonService.commonAPI(param)
      .then(response => response.data.message)
      .catch(error => console.error(error))
  }
};

export default HomeDashboardService;
